/*
 * @Author: M.D.
 * @Date: 2020-01-17 15:28:32
 * @LastEditors  : M.D.
 * @Description:
 * @Remarks:
 */
import { mapGetters } from 'vuex'
import _ from 'lodash'
import moment from 'moment'

export const usrStatus = {
  computed: {
    ...mapGetters(['userInfo']),
    // 是否登录
    isLogin () {
      return !_.isEmpty(this.userInfo)
    },
    isVip () {
      if (this.isLogin && this.userInfo.vipValidTime !== '') {
        return moment(this.userInfo.vipValidTime, 'YYYY-MM-DD HH:mm:ss').isAfter(moment())
        // return moment(this.userInfo.vipValidTime, 'YYYY-MM-DD HH:mm:ss').isAfter(moment('2019-01-01 00:00:01', 'YYYY-MM-DD HH:mm:ss'))
      } else {
        return false
      }
    }
  }
}
